/*
 * @desc 饼图 or 环形图 or 南丁格尔玫瑰图
 * @author xuyao
 * @param radius 区别环形与饼图 eg：[0, '75%'] 内半径与外半径
 * @param roseType 南丁格尔玫瑰图专用，可选择两种模式 radius/area
 */
import React, { PureComponent } from 'react';
import { colors, pageIconSetting, tooltipStyles } from './config/config';
import extend from './utils/extend';
import { getLegendData, createStandardData } from './utils/util';
import EchartBase from './base/EchartBase';

class BBDBasePie extends PureComponent {
    constructor(props) {
        super(props);
    }
    setOption(param) {
        let {
            color =  colors.color.slice(),
            labelShow = false,
            labelPosition = 'outside',
            center = ['30%', '50%'],
            radius = ['45%', '85%'],
            data = [],
            ...others
        } = param;

        let baseSeries = {   //  默认配置
            type: 'pie',
            center,
            radius,
            label: {
                normal: {
                    show: labelShow,
                    position: labelPosition,
                    formatter: '{d}%',
                    color: colors.textColor
                }
            }
        };

        let series = createStandardData(data, baseSeries);

        const option = {
            color,
            title: {
                text: '',
                x: '',
                left: 'auto',
                top: 'auto',
                bottom: 'auto',
                textStyle: {
                    fontSize: 14,
                    fontWeight: 'normal',
                    fontFamily: 'Microsoft Yahei',
                    color: colors.textColor
                }
            },
            tooltip: {
                trigger: 'item',
                padding: [5, 10, 5, 10],
                formatter: '{b}: {d}%',
                ...tooltipStyles
            },
            legend: {
                show: true,
                orient: 'vertical',
                left: '50%',
                top: 'middle',
                right: 'auto',
                bottom: 'auto',
                itemGap: 15,
                itemWidth: 12,
                itemHeight: 12,
                data: getLegendData(series, 'pie'),
                textStyle: {
                    fontSize: 14,
                    fontWeight: 'normal',
                    fontFamily: 'Microsoft Yahei',
                    color: colors.legendColor
                },
                ...pageIconSetting
            },
            series: series
        };

        let op = extend(true, {}, option, others);
        return op;
    }
    render() {
        return (
            <EchartBase option={this.setOption(this.props.option)} style = {this.props.style} />
        );
    }
}
export default BBDBasePie;



// WEBPACK FOOTER //
// ./src/components/common/echarts/BBDPie.jsx